export default __webpack_public_path__ + "static/media/review5.b251c82d.jpg";